module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("6Oeir"))).then(() => parcelRequire('aLwpY'));